document.addEventListener("DOMContentLoaded", function () {
  // Pilih semua dropdown Option Price Calculator
  const panelSelects = document.querySelectorAll('.option-price-calculator select');

  panelSelects.forEach(select => {
    select.addEventListener('change', () => {
      // Cek ada tak dropdown yang dah pilih value
      const selected = Array.from(panelSelects).find(s => s.value !== "");

      panelSelects.forEach(s => {
        // Kalau ada satu dipilih, disable semua dropdown lain
        if (s !== select) {
          s.disabled = selected ? true : false;
        }
      });
    });
  });
});
document.addEventListener("DOMContentLoaded", function () {
  // Pilih semua dropdown Option Price Calculator
  const panelSelects = document.querySelectorAll('.option-price-calculator select');

  panelSelects.forEach(select => {
    select.addEventListener('change', () => {
      // Check jika ada dropdown yang dah pilih value
      const selected = Array.from(panelSelects).find(s => s.value !== "");

      panelSelects.forEach(s => {
        if (s !== select) {
          // Disable semua dropdown lain jika ada pilihan
          s.disabled = selected ? true : false;
        }
      });
    });
  });
});
